import { Theme } from '@shared/services/theme/theme';

import { API_ENDPOINT, HeaderKey } from '../config/api-endpoints';
import { updateHeaders } from '../config/update-headers';
import env from './.env';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

let environment = {
  assetPath: '/assets/images/td',
  production: false,
  MSW: false,
  hmr: false,
  metrics: false,
  notifyError: false,
  appName: env.AppName,
  version: env.version + '-localhost',
  commit: env.commit,
  branch: env.branch,
  tier: 'develop',
  serverUrl: 'https://api-dev.tdshop.io',
  serverPosUrl: '',
  storageUrl: 'https://storage.googleapis.com',
  imgUrl: 'https://storage.googleapis.com/product-assortments-dev',
  storeResourcesPath: '/store-resources-dev',
  defaultClientId: 'ADMIN_PORTAL',
  defaultCountry: 'Thailand',
  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US', 'th'],
  theme: Theme.TD,
  blockSales: true,
  supplierName: 'TD Tawandang',
  prefixCompany: 'TD',
  companyTH: 'ทีดี ตะวันแดง',
  copyRight: '2019 TD Tawandang Co.,Ltd. All rightS reserved. www.tdshop.io',
  imgLogo: '/assets/images/td-logo.svg',
  imgLogoVertical: '/assets/images/vertical-logo-border.svg',
  dateFormat: 'DD/MM/YYYY',
  monthFormat: 'MM/YYYY',
  dateTimeFormat: 'YYYY-MM-DDTHH:mm:ss',
  dateTimeNanoSec: 'YYYY-MM-DDTHH:mm:ss.SSS',
  dateTimeDisplay: 'DD/MM/YYYY HH:mm',
  date_time: 'DDMMYYYY_HHmm',
  timeFormat: 'HH:mm',
  dateISO8601: 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
  uploadConcurrent: 4,
  uploadChunkSize: 10000,
  loadExistingChunkSize: 25000,
  favicon: 'favicon',
  period: {
    short: 1,
    medium: 3,
    long: 6
  },
  buyCoPromotionItem: 3,
  reportXHost: 'report.api.tdshop.io',
  merchantCompanyTax: '0105555026004',
  cookies: {
    maxSizePerCookies: 3500,
    bufferTimePeriod: 1800000,
    domain: 'localhost',
    path: '/',
    accessToken: 'bo-access-token',
    refreshToken: 'bo-refresh-token'
  },
  currencyOptions: null,
  alert: {
    myReportRequest:
      'System generated report Request No. {request_no}.<br/>You can download the file from My Report menu.'
  },
  autoExtendDays: 99,
  header: {
    contentDispositionAttachment: '&response-content-disposition=attachment'
  },
  importStoreGroupLimit: 1000,
  fileName: {
    exportDo: {
      prefix: 'Delivery Order Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportCompensate: {
      promotion: 'Promotion Compensate Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportVoucher: {
      prefixReport: 'Voucher Report',
      fileTemplate: 'Voucher Template',
      fileStoreTemplate: 'Store Template',
      fileSelectStore: 'Select Store',
      prefixFileError: 'Store Template Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportMoneyIn: {
      prefix: 'Money In Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportDestroyDocument: {
      prefix: 'Destroy Summary (PDF) Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPr: {
      prefix: 'Purchase Request Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPrSupplier: {
      errorExcel: 'PR Supplier Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPo: {
      prefix: 'Purchase Order Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportClaim: {
      prefix: 'Claim Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportReOrder: {
      prefix: 'Receive Order Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    downloadPdf: {
      timeFormat: 'DDMMYYYYHHmm'
    },
    exportStock: {
      prefixLocation: 'Stock by Location Report',
      prefixProduct: 'Stock by Product Report',
      prefixAdjustment: 'Stock Adjustment Report',
      prefixCard: 'Stock Card Report',
      timeFormat: 'DDMMYYYY_HHmm',
      titleStockAdjustmentTemplate: 'Stock Adjustment Template',
      prefixStockAdjustmentFileError: 'Stock Adjustment Error'
    },
    exportOrder: {
      prefix: 'Order Report',
      prefixError: 'Special Order Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportSalesTransaction: {
      prefixReport: 'Sales Transaction Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportSalesTransactionConfidential: {
      prefixReport: 'Sales Transaction Report (Confidential)',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPreOrderCatalog: {
      fileTemplate: 'Pre Order Catalog Template',
      fileFlashSaleTemplate: 'Flash Sale Template',
      prefixFileError: 'Pre Order Catalog Error',
      prefixFlashSaleFileError: 'Flash Sale Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportDeletedBill: {
      prefixReport: 'Deleted Bill Items Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportSalesSummary: {
      prefixReport: 'Sales Summary Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportShipment: {
      prefix: 'Shipment Report ',
      prefixError: 'Shipment Error',
      timeFormat: 'DDMMYYYY_HHmm',
      fileTemplate: 'Shipment Template'
    },
    exportMonthlyProfit: {
      prefix: 'Monthly Profit Sharing Report ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportReceiveOrderExceed: {
      prefix: 'Receive Order Exceed Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportStoreAssortment: {
      prefix: 'Store Assortment Report',
      fileSpecialAssortmentTemplate: 'Special Assortment Template',
      fileShelfOptionTemplate: 'Shelf Option Template',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportShelf: {
      prefix: 'Shelf Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportSupplierCouponReconcile: {
      prefix: 'Supplier Coupon Reconcile Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportShelfInventory: {
      prefix: 'Shelf Inventory Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportShelfFixAsset: {
      prefix: 'Shelf Fix Asset Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportInventoryCountTransactionTemp: {
      prefix: 'Inventory Count Transaction Report (with Price)',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportInventoryAdjustmentRequest: {
      prefix: 'Inventory Adjustment Request Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportProfitSharing: {
      prefix: 'Profit Sharing Report ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPromotionCompensate: {
      prefix: 'Promotion Compensate Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPromotion: {
      prefix: 'Promotion Report ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPromotionStoreRequest: {
      prefix: 'Store',
      fileTemplate: 'Store Template',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPromotionRequest: {
      prefix: 'Promotion Request',
      fileTemplate: 'Promotion Template',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportStore: {
      prefix: 'Store Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportStoreOrderSchedule: {
      prefix: 'Store Order Schedule Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportStoreConfidential: {
      prefix: 'Store Report (Confidential)',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportInventoryCountTransaction: {
      prefix: 'Inventory Count Transaction Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportOrderRequest: {
      prefix: 'Order Request',
      timeFormat: 'DDMMYYYY_HHmm',
      fileTemplate: 'Special Order Template'
    },
    exportInventoryVarianceReport: {
      prefix: 'Inventory Variance Report ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    printStoreAssortmentPdf: {
      prefix: 'Price Tag',
      timeFormat: 'DDMMYYYYHHmm'
    },
    exportRewardTransaction: {
      prefix: 'Reward Transaction Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportRewardCatalogReport: {
      prefix: 'Member Reward Catalog Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportRedeemTransaction: {
      prefix: 'Redeem Transaction Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportBillPayment: {
      prefix: 'Bill Payment Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportMemberRewardTransactionReport: {
      prefix: 'Member Reward Transaction Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportMemberRewardAccountingConfidentialReport: {
      prefix: 'Member Reward Accounting Report (Confidential)',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportSupplierPriceConfigs: {
      prefix: 'Supplier Price',
      timeFormat: 'DDMMYYYY_HHmm',
      fileTemplate: 'Supplier Price Template'
    },
    printPointStatementPdf: {
      prefix: 'Point Statement',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportSupplier: {
      prefix: 'Supplier Report',
      fileTemplate: 'Supplier List Template',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportRewardRequestConfigs: {
      prefix: 'Reward Request',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportReward: {
      prefix: 'Reward Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportStoreConsultant: {
      prefixReport: '',
      prefix: 'Store Consultant Report',
      prefixError: 'Store Consultant Error',
      fileTemplate: 'Store Consultant Template',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportTaskAssignment: {
      prefixReport: '',
      prefix: 'Store Consultant',
      prefixError: 'Store Error',
      fileTemplate: 'Store Template',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportApprovalWorkflow: {
      downloadFileTemplate: 'Template',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportTask: {
      prefix: 'Task Report ',
      timeFormat: 'DDMMYYYY_HHmm'
    },

    exportTaskAssignmentResponse: {
      prefix: 'Response Report ',
      timeFormat: 'DDMMYYYY_HHmm'
    },

    exportTaskAssignmentSurvey: {
      prefix: 'Survey Report ',
      timeFormat: 'DDMMYYYY_HHmm'
    },

    exportDestroyTransaction: {
      prefix: 'Destroy Transaction Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportTransferRequestTemplate: {
      prefix: 'Transfer Request Template',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportTransferOrder: {
      prefix: 'Transfer Order Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportItemCondition: {
      prefix: 'Item Discount Template',
      exported: 'Discount',
      errorExcel: 'Discount Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportOrderDeliveryScheduleWeeklyTemplate: {
      prefix: 'Order Delivery Schedule Weekly Template',
      exported: 'Order Delivery Schedule Weekly',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportOrderDeliveryScheduleMonthlyTemplate: {
      prefix: 'Order Delivery Schedule Calendar Template',
      exported: 'Order Delivery Schedule Calendar',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPrItem: {
      prefix: 'PR Supplier Template',
      exported: 'PR Supplier',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportTemporaryHold: {
      prefix: 'Temporary Hold Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportOrderProcessingHold: {
      prefix: 'Order Processing (Hold) Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportMemberExcludeItem: {
      prefix: 'Exclude Item Report ',
      fileTemplate: 'Exclude Item Template',
      errorExcel: 'Exclude Item Error ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportNotForSaleItem: {
      prefix: 'Not for Sale Item Report ',
      fileTemplate: 'Not for Sale Item Template',
      errorExcel: 'Not for Sale Item Error ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPointEarnTransactionItem: {
      prefix: 'Point Earn Transaction Report ',
      fileTemplate: 'Point Earn Transaction Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    downloadStoreAssortmentShelfDetails: {
      prefix: 'Store Assortment(Shelf)',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportUserReport: {
      prefix: 'User Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportLatePaymentNotice: {
      prefixReport: '',
      prefix: '',
      prefixError: '',
      fileTemplate: 'Late Payment Notice Details Template',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportRewardCatalog: {
      fileTemplate: 'Store Template',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportStoreOrderScheduleTemplate: {
      prefix: 'Store Order Schedule Template',
      exported: 'Store Order Schedule',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPreOrderTransaction: {
      prefix: 'Pre Order Transaction Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPreOrderAccounting: {
      prefix: 'Pre Order Accounting Report (Confidential)',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportRefund: {
      prefix: 'Refund Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportAwaitingAllocationForGroupOrder: {
      prefix: 'Awaiting Allocation for Group Order Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportGroupOrderUnpickedItem: {
      prefix: 'Group Order Unpicked Item Report',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportShelfInventoryTemplate: {
      fileTemplate: 'Shelf Inventory Template',
      prefixError: 'Shelf Inventory Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportSpecialPointTemplate: {
      fileTemplate: 'Special Point Template',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportHoldAssortmentRequest: {
      fileTemplate: 'Hold Assortment Template'
    },
    exportHoldAssortmentRequestNo: {
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportToteAdjustment: {
      prefix: '',
      fileTemplate: 'Tote Adjustment Template',
      errorExcel: 'Tote Adjustment Error ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    printReturnTotePdf: {
      prefix: 'ใบรับคืนลังพลาสติก',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportStoreAssortmentRequest: {
      fileTemplate: 'Store Assortment Template'
    },
    exportStoreAssortmentRequestNo: {
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportPreOrderCreditTerm: {
      prefix: 'Special Pre Order Credit Report ',
      fileTemplate: 'Special Pre Order Credit Template',
      errorExcel: 'Special Pre Order Credit Error ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportStoreAssortmentRecommendation: {
      prefix: 'Store Assortment Recommendation',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportHoldOrder: {
      fileTemplate: 'Hold Order Template',
      errorExcel: 'Hold Order Error ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportUnholdOrder: {
      fileTemplate: 'Unhold Order Template',
      errorExcel: 'Unhold Order Error ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    productWarehouseMapping: {
      fileTemplate: 'Product Warehouse Mapping',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    productCategoryInventory: {
      fileTemplate: 'Product Category (Inventory)',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    productCategoryFixAssetStoreUse: {
      fileTemplate: 'Product Category (Fix Asset & Store Use)',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    onlineProductCategoryOwnDelivery: {
      fileTemplate: 'Online Product Category (for Own Delivery)',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    preOrderCategory: {
      fileTemplate: 'Pre Order Category',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    saleSchedule: {
      fileTemplate: 'Sale Schedule',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    sapStoreCodeMapping: {
      fileTemplate: 'SAP Store Code Mapping',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    reduceToClearRate: {
      prefix: 'Reduce to Clear Rate',
      fileTemplate: 'Reduce to Clear Rate Template',
      errorExcel: 'Reduce to Clear Rate Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportReturnToWarehouse: {
      fileTemplate: 'Return to Warehouse (Store Terminate) Template',
      errorExcel: 'Return to Warehouse (Store Terminate) Error ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportSSPResultReport: {
      fileTemplate: 'SSP Result Report',
      timeFormat: 'DDMMYYYY_HHmm',
      dataFormat: 'DD-MM-YYYY'
    },
    printReceiveOrderPdf: {
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportStockCountRequest: {
      prefix: 'Stock Count',
      fileStoreTemplate: 'Store Template',
      fileItemTemplate: 'Select by Item Template',
      fileClassTemplate: 'Select by Class Template',
      storeExcel: 'Store',
      itemExcel: 'Stock Count (Select by Item)',
      classExcel: 'Stock Count (Select by Class)',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportSelectStoreTemplate: {
      fileTemplate: 'Store Template',
      fileDownload: 'Store',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportCashSettlementTemplate: {
      fileTemplate: 'Money Transfer Data',
      prefixError: 'Confirm Money Transfer Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportCafeCatalogTemplate: {
      prefix: 'Cafe Catalog',
      fileTemplate: 'Cafe Catalog Template',
      prefixError: 'Cafe Catalog Error',
      file: 'Cafe Catalog',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportStoreProfileAdvertisementTemplate: {
      prefix: 'Store Profile Advertisement',
      fileTemplate: 'Store Profile Advertisement',
      prefixError: 'Cafe Catalog Error',
      file: 'Cafe Catalog',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportCafeToppingTemplate: {
      prefix: 'Cafe Topping',
      fileTemplate: 'Cafe Topping Template',
      prefixError: 'Cafe Topping Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportCafeMenuStationMappingTemplate: {
      prefix: 'Cafe Menu Station Mapping',
      fileTemplate: 'Cafe Menu Station Mapping Template',
      prefixError: 'Cafe Menu Station Mapping Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportCafeMenuRestrictionTemplate: {
      prefix: 'Cafe Menu Restriction',
      fileTemplate: 'Cafe Menu Restriction Template',
      prefixError: 'Cafe Menu Restriction Error',
      file: 'Cafe Menu Restriction',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    refillStockSchedule: {
      fileTemplate: 'Shelf Replenishment Schedule',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    refillPriority: {
      fileTemplate: 'Shelf Replenishment Priority',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    storePickingUnit: {
      fileTemplate: 'Store Picking Unit',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    stockCountSchedule: {
      fileTemplate: 'Stock Count Schedule',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    pettyCashEventBased: {
      fileTemplate: 'Petty Cash Event-Based',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    pettyCashDefault: {
      fileTemplate: 'Petty Cash Default All Stores & Default by Store',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    singleLocationStockFrontStoreOnly: {
      fileTemplate: 'Single Location Stock (Front Store Only)',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportWorkInstructionStoreGroupTemplate: {
      fileTemplate: 'WI Store Group Template',
      prefixError: 'WI Store Group Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportWorkScheduleTemplate: {
      fileTemplate: 'Work Schedule Template',
      prefixError: 'Work Schedule Error',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportStoreGroup: {
      fileTemplate: 'Store Group Template',
      errorExcel: 'Store Group Error ',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    storeExpenseLimit: {
      fileTemplate: 'Store Expense Limit',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    department: {
      fileTemplate: 'Department',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    productBrand: {
      fileTemplate: 'Product Brand',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    productAttribute: {
      fileTemplate: 'Product Attribute',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    alternativeProducts: {
      fileTemplate: 'Alternative Products',
      timeFormat: 'DDMMYYYY_HHmm'
    },
    exportSpecialRetailPrice: {
      fileTemplate: 'Special Retail Price Template',
      prefix: 'Special Retail Price',
      errorExcel: 'Special Retail Price Error',
      timeFormat: 'DDMMYYYY_HHmm'
    }
  },
  regexp: {
    imageType: '.*.(gif|jpe?g|bmp|png)$'
  },
  services: {} as any,
  viewStore: {
    isShowHandDevice: false,
    isShowBuddyDevice: false,
    isShowAddPosDevice: false
  },
  setting: {
    configs: {
      saleSchedule: {
        blockTimes: {
          from: '22:00',
          to: '24:00'
        },
        allowDeleteAtProcess: {
          dateBefore: 1
        }
      },
      onlineProductCategoryOwnDelivery: {
        blockTimes: {
          from: '22:00',
          to: '24:00'
        }
      },
      refillStockSchedule: {
        blockTimes: {
          from: '22:00',
          to: '24:00'
        }
      },
      pettyCashEventBased: {
        blockTimes: {
          from: '22:00',
          to: '24:00'
        }
      },
      pettyCashDefault: {
        blockTimes: {
          from: '22:00',
          to: '24:00'
        }
      },
      singleLocationStockFrontStoreOnly: {
        blockTimes: {
          from: '22:00',
          to: '24:00'
        }
      },
      refillPriority: {
        blockTimes: {
          from: '22:00',
          to: '24:00'
        }
      },
      storePickingUnit: {
        blockTimes: {
          from: '22:00',
          to: '24:00'
        }
      },
      storeExpenseLimit: {
        blockTimes: {
          from: '22:00',
          to: '24:00'
        }
      }
    }
  },
  unleashUrl: 'https://unleash.dev-cjx.tdtech.app/api/frontend/',
  unleashClientKey: '*:development.536927169470069506a60af8a2c9967fb466026da7268e9e706c7d1d',
  unleashAppName: 'cjx-admin-portal',
  unleashEnvironment: 'development',
  unleashCustomHeaders: { 'UNLEASH-SDK': 'unleash-admin-portal-sdk:3.10.0' },
  unleashRefreshInterval: 60
};

export const X_HOST_HEADER = {
  [HeaderKey.Pim]: {
    'x-host': 'pim.api.tdtech.app'
  },
  [HeaderKey.Authorization]: {
    Authorization: 'Basic QURNSU5fUE9SVEFMOlBAc3N3MHJk',
    'x-host': 'oauth.api.tdshop.io'
  },
  [HeaderKey.Billing]: {
    'x-host': 'billing.api.tdshop.io'
  },
  [HeaderKey.DataInsight]: {
    'x-host': 'data-insight.api.tdshop.io'
  },
  [HeaderKey.Dashboard]: {
    'x-host': 'dashboard.api.tdshop.io'
  },
  [HeaderKey.Identity]: {
    'x-host': 'identity.api.tdshop.io'
  },
  [HeaderKey.Master]: {
    'x-host': 'master.api.tdshop.io'
  },
  [HeaderKey.Merchant]: {
    'x-host': 'merchant.api.tdshop.io'
  },
  [HeaderKey.Marketing]: {
    'x-host': 'marketing.api.tdshop.io'
  },
  [HeaderKey.Membership]: {
    'x-host': 'membership.api.tdshop.io'
  },
  [HeaderKey.NestExporter]: {
    'x-host': 'nest-exporter.api.tdshop.io'
  },
  [HeaderKey.NestMaster]: {
    'x-host': 'nest.master.api.tdshop.io'
  },
  [HeaderKey.Pos]: {
    'x-host': 'pos.api.tdshop.io'
  },
  [HeaderKey.Product]: {
    'x-host': 'product.api.tdshop.io'
  },
  [HeaderKey.Purchase]: {
    'x-host': 'purchase.api.tdshop.io'
  },
  [HeaderKey.Stock]: {
    'x-host': 'stock.api.tdshop.io'
  },
  [HeaderKey.Store]: {
    'x-host': 'store.api.tdshop.io'
  },
  [HeaderKey.Supplier]: {
    'x-host': 'supplier.api.tdshop.io'
  },
  [HeaderKey.Settlement]: {
    'x-host': 'settlement.api.tdshop.io'
  },
  [HeaderKey.Report]: {
    'x-host': 'report.api.tdshop.io'
  },
  [HeaderKey.Tote]: {
    'x-host': 'tote.api.tdshop.io'
  },
  [HeaderKey.Order]: {
    'x-host': 'order.api.tdshop.io'
  },
  [HeaderKey.Workflow]: {
    'x-host': 'workflow.api.tdshop.io'
  }
};

environment.services = updateHeaders(API_ENDPOINT, X_HOST_HEADER);

export { environment };
